// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__c1X2B","rightAdornment":"Header_rightAdornment__1qG6w"};